import React from 'react';
import { content, contactInfo } from '../data/mock';
import './Footer.css';

const Footer = ({ language }) => {
  const t = content[language].footer;

  return (
    <footer>
      <div className="container footer-inner">
        <div>
          <strong>Brilliant Touch</strong>
          <br />
          <span>{t.tagline}</span>
        </div>
        <div className="footer-links">
          <a href={`tel:${contactInfo.phone}`}>{contactInfo.phoneDisplay}</a>
          {' · '}
          <a href={`mailto:${contactInfo.email}`}>{contactInfo.email}</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
